
import { Component } from "vue-property-decorator";
import ActivityDependendViewBase from "@/app/views/activity-dependend-view.base";
import OverviewComponent from "@/app/dynamic-components/overviews/overview-component.vue";
import PageHeader from "@/components/layout/PageHeader.vue";
import AcceptPoliciesInterceptor from "@/components/common/AcceptPoliciesInterceptor.vue";
import AuthenticationInterceptor from "@/components/common/AuthenticationInterceptor.vue";
import Loader from "@/components/common/Loader.vue";
import ActionTile from "@/app/components/common/ActionTile.vue";
import MyDocumentsView from "@/views/documents/MyDocumentsView.vue";
import ActivityDefinitionModel, {ActivityProductsDefinitionModel, ActivityProductsDefinitionRulesModel} from "@/app/models/activity/activity-definition.model";
import {
  FormDialogControl,
  FormDialogModel,
} from "@/app/components/dialog/form-dialog.model";
import { ExternalContext } from "@/app/contexts/externalContext";
import FormDialogComponent from "@/app/components/dialog/form-dialog-component.vue";
import { RenderType } from "@/app/Types";
import { DynamicForm } from "@/app/dynamic-components/forms/dynamic-form.model";
import { productService } from "@/app/services/product.service";
import { OverviewControl } from "@/app/dynamic-components/overviews/overiew.model";
import { Overview } from "@/app/models/overview/overview.model";
import {ruleEngine} from "@/app/services/rule.engine";
import Vue from "vue";

@Component({
  components: {
    FormDialogComponent,
    MyDocumentsView,
    ActionTile,
    Loader,
    AuthenticationInterceptor,
    AcceptPoliciesInterceptor,
    PageHeader,
    OverviewComponent,
  },
})
export default class ProductsOverviewView extends ActivityDependendViewBase {
  externalContext: ExternalContext = new ExternalContext();
  modifyOrCreatePublicProduct = false;
  tabs: any
  rules : {
    canCreateCompanyProduct : boolean,
    canUpdateCompanyProduct : boolean,
    canDeactivateCompanyProduct : boolean,
    canCreateActivityProduct : boolean,
    canUpdateActivityProduct : boolean,
    canDeactivateActivityProduct : boolean
    canViewAllCompanyProducts: boolean
  } = {
    canCreateCompanyProduct : false,
    canUpdateCompanyProduct : false,
    canDeactivateCompanyProduct : false,
    canCreateActivityProduct : false,
    canUpdateActivityProduct : false,
    canDeactivateActivityProduct : false,
    canViewAllCompanyProducts : false
  }

  additionalFiltersOwn: { [key: string]: string } = {};
  additionalMetadataOwn: { [key: string]: any } = {};

  additionalFiltersPublic: { [key: string]: string } = {};
  additionalMetadataPublic: { [key: string]: any } = {};

  overviewCorpProductControl: OverviewControl | null = null;
  overviewActivityProductControl: OverviewControl | null = null;

  createNewProductControl: FormDialogControl | null = null;
  updateProductControl: FormDialogControl | null = null;

  async onPageReady(): Promise<any> {
    this.externalContext = new ExternalContext();
    if(this.activityDefinition?.products?.rules){
      this.rules.canCreateActivityProduct = this.activityDefinition.products.rules.canCreateActivityProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canCreateActivityProduct || '', this) : false;
      this.rules.canCreateCompanyProduct = this.activityDefinition.products.rules.canCreateCompanyProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canCreateCompanyProduct || '', this) : false;
      this.rules.canDeactivateActivityProduct = this.activityDefinition.products.rules.canDeactivateActivityProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canDeactivateActivityProduct || '', this) : false;
      this.rules.canDeactivateCompanyProduct = this.activityDefinition.products.rules.canDeactivateCompanyProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canDeactivateCompanyProduct || '', this) : false;
      this.rules.canUpdateCompanyProduct = this.activityDefinition.products.rules.canUpdateCompanyProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canUpdateCompanyProduct || '', this) : false;
      this.rules.canUpdateActivityProduct = this.activityDefinition.products.rules.canUpdateActivityProduct ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canUpdateActivityProduct || '', this) : false;
      this.rules.canViewAllCompanyProducts = this.activityDefinition.products.rules.canViewAllCompanyProducts ? await ruleEngine.resolveRuleAsync(this.externalContext ,this.activityDefinition?.products?.rules.canViewAllCompanyProducts || '', this) : false;
    }


    this.additionalFiltersOwn = {
      nrq_ispublic: 'false'
    };
    if(!this.rules.canViewAllCompanyProducts){
      this.additionalFiltersOwn['nrq_ownerorganisation'] = this.$store.state.user.organizationId;
    }

    this.additionalFiltersPublic = {
      nrq_ispublic: 'true'
    };

    const activityDefinition = this.$store.state.activity.currentActivityDefinition as ActivityDefinitionModel;
    this.additionalMetadataOwn.activitydefinition = activityDefinition;
    this.additionalMetadataPublic.activitydefinition = activityDefinition;
  }

  public recieveOverviewControlActivity(control: OverviewControl) {
    this.overviewActivityProductControl = control;
  }

  public recieveOverviewControlCorp(control: OverviewControl) {
    this.overviewCorpProductControl = control;
  }


  public async refreshOverview(): Promise<boolean> {
    this.overviewCorpProductControl?.refresh();
    this.overviewActivityProductControl?.refresh();
    return true;
  }

  public mapApiProductToProduct(overview: Overview): Overview {
    overview._embedded.results = overview?._embedded?.results?.map((val) => {
      return productService.convertGetProductToProduct(val);
    });
    return overview;
  }

  recieveCreateNewProductControl(control: FormDialogControl) {
    this.createNewProductControl = control;
    control.submitChanges = this.saveNewProduct;
    control.afterSubmitChanges = this.refreshOverview;
  }

  public async saveNewProduct(
    form: DynamicForm,
    formData: any
  ): Promise<boolean> {
    if (formData.custom_materialType) {
      formData.materialType = formData.materialTypeManual;
    }
    if (formData.custom_manufacturer) {
      formData.manufacturer = formData.manufacturerManual;
    }
    formData.isPublic = this.modifyOrCreatePublicProduct;
    form.patchForm(formData)
    console.warn('set data', form.getData().form);
    return productService.createProduct(form, formData).then((value) => {
      this.createNewProductControl?.setReferenceId(value);
      return !!value;
    });
  }

  recieveUpdateProductControl(control: FormDialogControl) {
    this.updateProductControl = control;
    control.submitChanges = this.updateProduct;
    control.afterSubmitChanges = this.refreshOverview;
    control.destroyItem = this.deactivateProduct;
    control.afterDestroyItem = this.refreshOverview;
  }

  public async deactivateProduct(
    form: DynamicForm,
    formData: any,
    referenceId: string
  ): Promise<boolean> {
    if (formData.custom_materialType) {
      formData.materialType = formData.materialTypeManual;
    }
    if (formData.custom_manufacturer) {
      formData.manufacturer = formData.manufacturerManual;
    }
    formData.isPublic = this.modifyOrCreatePublicProduct;
    return productService
      .deleteProduct(form, referenceId, formData)
      .then((value) => !!value);
  }

  public async updateProduct(
    form: DynamicForm,
    formData: any,
    referenceId?: string
  ): Promise<boolean> {
    if (formData.custom_materialType) {
      formData.materialType = formData.materialTypeManual;
    }
    if (formData.custom_manufacturer) {
      formData.manufacturer = formData.manufacturerManual;
    }
    this.updateProductControl?.setReferenceId(referenceId || "nan")
    formData.isPublic = this.modifyOrCreatePublicProduct;
    form.patchForm(formData)
    return productService
      .updateProduct(form, this.updateProductControl?.getReferenceId() || "nan", formData)
      .then((value) => !!value);
  }

  showCreateDialog(publicProduct: boolean) {
    this.modifyOrCreatePublicProduct = publicProduct;
    this.createNewProductControl?.show();
  }

  showUpdateDialog(item: { item: any; index: number }) {
    this.modifyOrCreatePublicProduct = false;
    this.updateProductControl?.show(item.item.id, item.item);
  }

  showPublicUpdateDialog(item: { item: any; index: number }) {
    this.modifyOrCreatePublicProduct = true;
    this.updateProductControl?.show(item.item.id, item.item);
  }

}
